import React from 'react';
import { LockModalProps } from './types';
import { Button } from '@vtbhome/juicyfront';
import { Body, Footer, Subscription } from './modal-lock-user.styles';
import { Typography } from '@shared/ui/typography/typography';
import { UserInfo } from '../user-info/user-info';
import { getUserStatus } from '@shared/lib/utils/get-user-status/get-user-status';
import { useUserLockMutation } from '../../api/user-lock-api';
import { CACHE_KEY_USER_LOCK } from '../../config/api-constants';
import { Modal } from '@shared/ui/modal/modal';
import { userName } from '@shared/lib/utils/user-name/user-name';

export const ModalLockUser: React.FC<LockModalProps> = ({ isShow, user, onClose, onAccept }) => {
    const [lockUser, lockUserResult] = useUserLockMutation({ fixedCacheKey: CACHE_KEY_USER_LOCK });
    const isLoading = lockUserResult.isLoading;

    const handleAccept = async () => {
        await lockUser({
            id: user.id,
            active: !user.active,
        });
        onAccept();
    };

    return (
        <Modal
            isShow={isShow}
            size='l'
            showLine={false}
            header={
                <Typography size='h5'>
                    {getUserStatus(user) === 'disabled' ? 'Разблокирование пользователя' : 'Блокировка пользователя'}
                </Typography>
            }
            footer={
                <Footer>
                    <Button disabled={isLoading} buttonType='light' onClick={onClose}>
                        Отменить
                    </Button>
                    <Button preloader={isLoading} disabled={isLoading} buttonType='primary' onClick={handleAccept}>
                        Подтвердить
                    </Button>
                </Footer>
            }
            onClose={onClose}>
            <Body>
                <Subscription size='body1_short'>
                    Вы действительно хотите {getUserStatus(user) === 'disabled' ? 'разблокировать' : 'заблокировать'}{' '}
                    данного пользователя?
                </Subscription>
                <UserInfo
                    avatarUrl={user.photoUrl}
                    name={
                        userName({
                            firstName: user.firstName || '',
                            lastName: user.lastName || '',
                            middleName: user.middleName || '',
                        }).full
                    }
                    organizationPost={user.jobTitle}
                    status={getUserStatus(user)}
                />
            </Body>
        </Modal>
    );
};
